import { connect } from 'react-redux';
import CardThreeUp from '../../../shared/scripts/components/CardThreeUp/CardThreeUp';

const mapStateToProps = state => {
    return state;
};

const mapDispatchToProps = dispatch => {
    return {};
};

/**
 * Connects the component to the Redux store
 * @returns {*}
 * @constructor
 */
const CardThreeUpContainer = () => {
    return connect(mapStateToProps, mapDispatchToProps)(CardThreeUp);
};

export default CardThreeUpContainer;
